import { useCallback, useRef } from 'react'
import useMediaQueryBreakpoint from '@hooks/useMediaQueryBreakpoint'
import InputGrid from '@components/search/forms/FormWizardContainer'
import RangeSlider from '@components/form/new-inputs-for-context-form/RangeSlider'
import triggerReactEvent from '@utils/dom/triggerReactEvent'
import mix from '@utils/styles/mix'
import BREAKPOINTS from '@constants/breakpoints'

import styles from 'styles/payment/DragInput.module.css'
import inputStyles from '@components/form/new-inputs-for-context-form/Input.module.css'

function DragInput({
	amount = 60,
	breakpoint,
	className,
	inject,
	injectLabel,
	inputClass,
	min = 1,
	max = 120,
	name = 'amount',
	onChange,
	progressStyle,
	step = 5,
	unit = 'zł',
}) {
	const onMobile = useMediaQueryBreakpoint(
		breakpoint || BREAKPOINTS.showHamburger,
	)

	const inputRef = useRef()
	const sliderRef = useRef()

	const _onChange = useCallback(
		({ target: { value } }) => {
			const v = minmax(value, min, max)
			onChange(v)
			inputRef.current.value = v || ''
			if (sliderRef.current.value != v)
				triggerReactEvent(sliderRef.current, v)
		},
		[max, min, onChange],
	)

	const validate = useCallback(({ target: { value } }) => {
		inputRef.current.value = String(value).replace(/\D+/g, '')
	}, [])

	return (
		<InputGrid className={className}>
			{inject}
			<RangeSlider
				defaultValue={amount}
				injectLabel={injectLabel}
				max={max}
				min={min}
				onChange={_onChange}
				progressStyle={progressStyle}
				forwardRef={sliderRef}
				step={step}
				type="range"
				style={inject || onMobile ? undefined : { gridColumn: '1/3' }}
			/>

			<div className={styles.unit}>
				<div
					className={mix([
						inputStyles['input-outer'],
						inputStyles.solid,
					])}
				>
					<input
						className={mix([inputStyles.input, inputClass])}
						defaultValue={amount}
						ref={inputRef}
						name={name}
						onBlur={_onChange}
						onInput={validate}
						type="number"
					/>
				</div>
				<span>{unit}</span>
			</div>
		</InputGrid>
	)
}

function minmax(value, min, max) {
	if (isNaN(value) || value < min) return min
	if (value > max) return max
	return value
}

export { DragInput }
